import { render, staticRenderFns } from "./classic_monitoring_view.vue?vue&type=template&id=795b1c2f&scoped=true&"
import script from "./classic_monitoring_view.vue?vue&type=script&lang=js&"
export * from "./classic_monitoring_view.vue?vue&type=script&lang=js&"
import style0 from "./classic_monitoring_view.vue?vue&type=style&index=0&id=795b1c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b1c2f",
  null
  
)

export default component.exports